<template>
    <loader v-if="loading" />
    <div v-else>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title class="d-flex justify-center align-center">
                        <div>
                            Du er på niveau {{ user.level }}
                            &nbsp;
                            <v-icon color="green" v-if="user.newLevel > user.level">
                                fa-arrow-up
                            </v-icon>
                            <v-icon color="green" v-else-if="!settings.levels[user.level + 1] && user.newLevel === user.level">
                                fa-arrow-left
                            </v-icon>
                            <v-icon color="yellow darken-2" v-else-if="user.newLevel === user.level">
                                fa-arrow-left
                            </v-icon>
                            <v-icon color="red" v-else>
                                fa-arrow-down
                            </v-icon>
                        </div>
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <kpi-card title="Ringetid" icon="fa-headset" :value="user.effectiveDuration" :formatter="$options.filters.duration"></kpi-card>
                            </v-col>
                            <v-col>
                                <kpi-card title="Solgt præmie" icon="far fa-money-bill-alt" :value="user.total"></kpi-card>
                            </v-col>
                            <v-col>
                                <kpi-card title="Afsluttede emner" icon="fa-users" :value="user.leadCount"></kpi-card>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <kpi-card title="Besvarelser" icon="fa-reply" :value="user.responseCount" :target="settings.minimumResponseCount" color="red"></kpi-card>
                            </v-col>
                            <v-col>
                                <kpi-card
                                    title="Salg pr. emne"
                                    icon="fas fa-comment-dollar"
                                    :value="user.avgLead"
                                    :target="settings.levels[user.level].minimumAvgLead"
                                    :nextTarget="settings.levels[user.level + 1] ? settings.levels[user.level + 1].minimumAvgLead : 0" />
                            </v-col>
                            <v-col>
                                <kpi-card
                                    title="Salg pr. tildelt møde 14 dage"
                                    icon="fa-handshake"
                                    :value="user.avgMeeting"
                                    :subText="`(${user.periodMeetingCount} møder)`"
                                    :target="settings.levels[settings.levels.length - 1].minimumAvgMeeting" />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <kpi-card title="TMK" icon="far fa-smile" :value="user.TMK" :target="settings.minimumTMK" />
                            </v-col>
                            <v-col>
                                <kpi-card title="Bonus" icon="fa-coins" :value="user.bonus" :target="settings.minimumBonus" />
                            </v-col>
                            <v-col>
                                <kpi-card title="Gennemgang" icon="fa-clipboard-check" :value="user.examination" :target="settings.minimumExamination" />           
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import kpiCard from '@/components/kpiCard'

export default {
    components: {
        kpiCard
    },
    data () {
        return {
            loading: true,
            user: null
        }
    },
    computed: {
    },
    methods: {
        async getData () {
            this.loading = true
            let response = await this.$http().get(`/user/dashboard/${this.$store.state.main.uniqueId}`)
            this.user = response.data.user
            this.settings = response.data.settings
            this.loading = false
        }
    },
    created () {
        this.getData()
    }
}
</script>